import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Section Components (Landing Page)
import Hero from './components/Hero';
import AppPreview from './components/AppPreview';
import Features from './components/Features';
import WhyRetailMitra from './components/WhyRetailMitra';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import WhatsAppButton from './components/WhatsAppButton';

// New Legal Pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// This component groups all your landing page sections
const MainLanding = () => (
  <>
    <Hero />
    <AppPreview />
    <Features />
    <WhyRetailMitra />
    <HowItWorks />
    <Pricing />
    <Testimonials />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Navbar />
        <Routes>
          {/* Main Website Route */}
          <Route path="/" element={<MainLanding />} />
          
          {/* Legal Routes */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;